import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

import { useSettings } from '../mall_settings/SettingsProvider';
import { userClient } from "./userClient";
import { loginUrl } from "./utils";

export const UserContext = React.createContext();

export const UserProvider = ({ children }) => {
    const { hasAuthentication, authenticationRequired } = useSettings();
    
    const [hasAuth, setHasAuth] = useState(hasAuthentication);
    const [userData, setUserData] = useState({});
    const [fetching, setFetching] = useState(true);
    const [fetchError, setFetchError] = useState(false);

    const [amountUsed, setAmountUsed] = useState(0);
    const [amountRemaining, setAmountRemaining] = useState(0);

    useEffect(() => {
        const available = userData && userData.availableAmount ? userData.availableAmount : 0;
        setAmountRemaining(available - amountUsed);
    }, [userData, amountUsed, hasAuth]);

    useEffect(() => {
        userClient.getUser().then((data) => {
            const loginStatus = data && Object.keys(data).length > 0 ? 'true' : 'false';
            window.localStorage.setItem('login_status', loginStatus);
            setUserData(data);
            setFetching(false);
        }).catch((err) => {
            window.localStorage.setItem('login_status', 'false');
            setFetchError(err);
            setFetching(false);

            
            
            if (authenticationRequired) {
                
                alert("There was a problem retrieving your account information. Click 'Ok' to redirected to the login page. If you continue to see this error, please try again later.");
                window.location.href = loginUrl;
            }
        })
    }, [hasAuth]);

    return (
        <UserContext.Provider
            value={{
                userData,
                fetching,
                fetchError,
                setAmountUsed,
                amountRemaining
            }}
        >
            {children}
        </UserContext.Provider>
    );
};

UserProvider.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

export const useUsers = () => useContext(UserContext);
